import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ReplaceParams } from '@fcom/core/utils';
import { FinnairAmount } from '@fcom/dapi/api/models';

/**
 * One row of a shopping cart bound's listing: an optional count and icon, a title, and an optional price.
 * Presentation only — the caller resolves its own copy, count and price and hands the finished values over,
 * so the included-benefit rows and the purchasable product lines share one row layout.
 */
@Component({
  selector: 'fin-shopping-cart-line-item',
  standalone: false,
  templateUrl: './shopping-cart-line-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingCartLineItemComponent {
  // Rendered as an "N x" prefix. Left out when the count is already part of the title copy, as it is for a
  // localized benefit row that passes the count as a title parameter instead.
  count = input<number>();
  icon = input<SvgLibraryIcon>();
  // The title as either plain text or a localization key with its parameters; plain text wins if both are set.
  title = input<string>();
  titleKey = input<string>();
  titleParams = input<ReplaceParams>();
  price = input<FinnairAmount>();
  // Bundle lines colour their price to mark it as the discounted one.
  accentPrice = input(false);
  // The child rows of a bundle line are indented under it.
  indented = input(false);
  testId = input<string>();
}
